import { db, COLLECTIONS } from './firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

export interface LeadData {
  name?: string;
  email?: string;
  phone?: string;
  property?: string;
  source: string;
  status: 'New' | 'In Progress' | 'Interested' | 'Rejected';
  message?: string;
}

export const recordLead = async (data: Partial<LeadData>) => {
  try {
    const leadRef = collection(db, COLLECTIONS.LEADS);
    await addDoc(leadRef, {
      ...data,
      time: 'Just Now',
      createdAt: serverTimestamp(),
      status: data.status || 'New',
      source: data.source || 'Website',
    });
    console.log('Lead recorded successfully');
  } catch (error) {
    console.error('Error recording lead:', error);
  }
};

export const recordSiteVisit = async (data: any) => {
  try {
    const visitRef = collection(db, COLLECTIONS.VISITS);
    await addDoc(visitRef, {
      property: data.property,
      visitor: data.name, // Mapping 'name' to 'visitor' for Admin UI
      contact: `${data.phone} / ${data.email}`, // Mapping to 'contact' for Admin UI
      date: data.date,
      time: data.time,
      status: 'Pending',
      createdAt: serverTimestamp(),
    });
    console.log('Site visit recorded successfully');
  } catch (error) {
    console.error('Error recording site visit:', error);
  }
};
